"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _default2 = exports.default = {
  props: {
    // /* 表单输入控件 */
    // control: {
    //   type: Array,
    //   default: () => ([])
    // },
    /* 多个组件 */
    items: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(v) {
        if (Array.isArray(v)) {
          v.forEach(function (item) {
            var _item$value;
            (_item$value = item.value) !== null && _item$value !== void 0 ? _item$value : item.value = '';
          });
          return true;
        } else {
          console.error('wl-form-control组件items参数必须为数组');
          return false;
        }
      }
    },
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    setFormItesms: {
      typeof: Function,
      default: function _default() {}
    },
    formItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    debug: {
      type: Boolean,
      default: false
    },
    grid: {
      type: [Number, Object],
      default: function _default() {
        return {};
      }
    }
  }
};